<div class="form-group" [class.has-error]="showError">
  <label *ngIf="props.label && props.hideLabel !== true" [attr.for]="id">
    {{ props.label }}
    <span *ngIf="props.required && props.hideRequiredMarker !== true">*</span>
  </label>

  <div>
    <input nbInput fieldSize="small" placeholder="Выберите дату и время" [nbDatepicker]="dateTimePicker" [formControl]="formControl" [formlyAttributes]="field"/>

    <nb-date-timepicker
      #dateTimePicker
      singleColumn
      [filter]="filterFn"
      format="dd.MM.yyyy HH:mm:ss"
      [step]="10">
    </nb-date-timepicker>
  </div>
  <div *ngIf="showError" class="invalid-feedback" [style.display]="'block'">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>
  <small *ngIf="props.description" class="form-text text-muted">{{ props.description }}</small>
</div>
